<template>
  <div>

    <a  @click="fnShowModal()" class="p-2"><i class="far fa-edit text-primary"></i></a>

    <b-modal ref="modal" hide-footer title="Employment status - update">
        <div class="d-block">
          <form>

            <div class="form-group">
              <label for="name">Status</label>
              <input type="text" 
              class="form-control" 
              id="name" 
              placeholder="Status"
              v-model="name">
              <div class="invalid-feedback" v-if="errors.name">{{ errors.name[0] }}</div>
            </div>
           <b-form-checkbox
                id="checkbox-1"
                v-model="status"
                name="checkbox-1"
                value="1"
                unchecked-value="0"
                >
                Status
            </b-form-checkbox>
          <hr>
          <div class="text-right">
            <button type="button" class="btn btn-secondary btn-sm mr-2" @click="hideModal">Cancel</button>
            <button  type="button" @click="fnUpdate()" class="btn btn-success btn-sm">Update</button>
          </div>
          </form>
        </div>
      </b-modal>
  </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex';
    import * as messageService from '../../services/message.service';
    import * as employmentStatusService from '../../services/employmentStatus.service';
    export default {
        name:"ModalEmploymentStatusEdit",
        props:['propsData'],
        components: {
            
        },
        data(){
            return{
                errors:{},
                id:'',
                name:'',
                status:'',
            }
        },
        computed:{
            ...mapGetters(['gettEmploymentStatusAll']),
        },
        methods:{
            ...mapActions(['fetchEmploymentStatusAll']),
            fnShowModal(){
                this.fnGetValue(this.propsData)
                this.showModal();
            },
            hideModal(){
                this.$refs.modal.hide();
            },
            showModal(){
                this.$refs.modal.show();
            },

            fnGetValue(props){
                this.id = props.rowData.id;
                this.status = props.rowData.status;
                this.name = props.rowData.name;
            },

            fnUpdate:async function(){
                const obj = {
                    "name":this.name,
                    "status":this.status
                }

                try{
                    const response = await employmentStatusService.update(this.id, obj);
                    this.fetchEmploymentStatusAll();
                    messageService.fnSweetAlertSuccessToast('Employment status', 'Updated successfully ');
                    this.hideModal();

                }catch(error){
                    messageService.fnSweetAlertErrorToast('Employment status - update', error.response.data.message);
                }

                this.id = ''; 
                this.name = '';
                this.status ='';
            }
        }
    }
</script>